module.exports = __webpack_public_path__ + "img/youan.e01d9232.png";